import Need from "../Need";

export const NeedRegionsView = new Need('regions.view');
export const NeedRegionsManage = new Need('regions.manage');
export const NeedRegionsDelete = new Need('regions.delete');
